import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=4a95a574&scoped=true"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=4a95a574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a95a574",
  null
  
)

export default component.exports